export default __webpack_public_path__ + "static/media/640_dummy2016-personaltrainer01-de.3108d78a.png";